export default __webpack_public_path__ + "static/media/combined_petro.logo.2bee3ad7.png";